import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'je-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  title: string;
  body: string;
  footer: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.body = this.data.body;
    this.footer = this.data.footer;
  }
}
